import useCognito from "./hooks/useCognito";

const Cognito = () => {
  useCognito();

  return null;
};

export default Cognito;
